import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/brand/brand/apps/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import ComponentLayout from '../../../src/layouts/component-layout';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const DoDontContainer = makeShortcode("DoDontContainer");
const Do = makeShortcode("Do");
const Caption = makeShortcode("Caption");
const Dont = makeShortcode("Dont");
const layoutProps = {
  _frontmatter
};
const MDXLayout = ComponentLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <p><img parentName="p" {...{
        "src": "https://github.com/primer/brand/assets/175638/203f49ae-e87c-4b66-8df0-22a1c8bad1b6",
        "alt": "A river component used to showcase a security feature. The title reads \"Get security feedback with every git push\" and it includes an image showing screenshots of of a CLI prompt with the git push command and a code scanning screenshot."
      }}></img></p>
    <h2>{`Usage`}</h2>
    <p>{`Use rivers to showcase features and introduce topics. Rivers compose images or videos and text together. River's text includes a heading, body text, and an optional link.`}</p>
    <p>{`River content should be short and concise, no longer than 3 or 4 sentences and in a single paragraph when possible.`}</p>
    <DoDontContainer mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img alt="" src="https://github.com/primer/brand/assets/175638/8b3057f9-00c5-4bf5-af44-00b0129c6c6e" />
    <Caption mdxType="Caption">Write short and concise text content.</Caption>
  </Do>
  <Dont mdxType="Dont">
    <img alt="" src="https://github.com/primer/brand/assets/175638/ea902be3-2032-49de-bdb4-23be0c0f090d" />
    <Caption mdxType="Caption">Don't overload the river with too much content.</Caption>
  </Dont>
    </DoDontContainer>
    <h3>{`Stacked`}</h3>
    <p>{`Two or more rivers can be stacked to guide the user through a set of feautres. When stacking rivers, use alternating between left and right alignments to create a more dynamic reading flow. When alternating alignments, use a `}<inlineCode parentName="p">{`40:60`}</inlineCode>{` image to text ratio, otherwise keep the ratio to `}<inlineCode parentName="p">{`50:50`}</inlineCode>{`.`}</p>
    <DoDontContainer mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img alt="" src="https://github.com/primer/brand/assets/912236/2b763c62-4d56-4d60-9cae-f663407e0506" />
    <Caption mdxType="Caption">Alternate rivers with left and right alignments.</Caption>
  </Do>
  <Dont mdxType="Dont">
    <img alt="" src="https://github.com/primer/brand/assets/912236/6c7b42a7-0048-4539-99f3-a1c3beb8ee70" />
    <Caption mdxType="Caption">
      Don't stack numerous rivers with 40:60 ratio without alternating left and
      right alignments.
    </Caption>
  </Dont>
    </DoDontContainer>
    <p>{`Note that too many rivers can make the design feel repetitive. In that situation, consider introducing a breakout section or break the content with a different component, such as `}<a parentName="p" {...{
        "href": "/components/Pillar"
      }}>{`pillar`}</a>{` or `}<a parentName="p" {...{
        "href": "/components/Card"
      }}>{`card`}</a>{` to provide a better visual hierarchy and experience. For example, use the river for the top features you want to highlight and then use pillars to showcase the rest.`}</p>
    <DoDontContainer mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img alt="" src="https://github.com/primer/brand/assets/912236/c847e394-3062-4b2a-83d5-77142aafed67" />
    <Caption mdxType="Caption">
      Use pillars or cards to breakout a multiple river section and provide a
      better visual hierarchy.
    </Caption>
  </Do>
  <Dont mdxType="Dont">
    <img alt="" src="https://github.com/primer/brand/assets/912236/8eb9d19c-8869-4efd-8f72-ea003e5516c4" />
    <Caption mdxType="Caption">
      Don't stack numerous rivers without breaking the content to avoid
      repetitive a layout that can make the design feel repetitive.
    </Caption>
  </Dont>
    </DoDontContainer>
    <h3>{`Sections with rivers`}</h3>
    <p>{`A single river component acts as a section and it should not include any child sections within in. Multiple rivers can be used to conform a section. In that case, the section should include a `}<a parentName="p" {...{
        "href": "/components/SectionIntro"
      }}>{`section intro`}</a>{` that introduces the main topic or features.`}</p>
    <DoDontContainer mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img alt="" src="https://github.com/primer/brand/assets/912236/b4339bb2-419b-4ffc-98ff-23f76d190496" />
    <Caption mdxType="Caption">Use a section intro to introduce multiple rivers.</Caption>
  </Do>
  <Dont mdxType="Dont">
    <img alt="" src="https://github.com/primer/brand/assets/912236/8b503c41-5715-4757-a3cd-23614308b0ab" />
    <Caption mdxType="Caption">
      Don't add child sections or other components to the river body content.
    </Caption>
  </Dont>
    </DoDontContainer>
    <h3>{`Breakout river`}</h3>
    <p>{`A river breakout component has an image that fills the width of the container while providing more space for content such as text and lists.`}</p>
    <p>{`This is useful when you want to create a highlight which can be used to create more emphasis or simply break a monotonous vertical flow of left/right rivers. It can also be helpful on smaller viewports to avoid stacking two images or two chunks of text from adjacent river components.`}</p>
    <p>{`Some examples of when to use a breakout river:`}</p>
    <ul>
      <li parentName="ul">{`Expand on more complex feature that require more room for content`}</li>
      <li parentName="ul">{`Give designer a tool to emphasize the feature story`}</li>
      <li parentName="ul">{`Use a branded wallpaper in a more cinematic way than the standard 50/50 or 60/40 text-to-image column ratios`}</li>
    </ul>
    <DoDontContainer mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img alt="" src="https://github.com/primer/brand/assets/2313998/103940cc-d3fc-47da-94c3-698c7c0c9b4a" />
    <Caption mdxType="Caption">
      Use a river breakout to emphasize a part of the river or break up a series
      of river components.
    </Caption>
  </Do>
  <Dont mdxType="Dont">
    <img alt="" src="https://github.com/primer/brand/assets/2313998/e23fcbc7-a974-4e3e-8551-5e2346813093" />
    <Caption mdxType="Caption">
      Don't stack river breakouts on top of other river breakout components or
      center-aligned river components. These both show a full-width image. This
      diminishes the visual impact the river breakout is intended to provide.
    </Caption>
  </Dont>
    </DoDontContainer>
    <p>{`The headline in the river component must always be present, but the supplemental content is optional.`}</p>
    <DoDontContainer mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img alt="" src="https://github.com/primer/brand/assets/2313998/433b1fba-4505-452b-8f8c-7cda69cc316d" />
    <Caption mdxType="Caption">Exclude the supplemental content if it's not needed.</Caption>
  </Do>
  <Dont mdxType="Dont">
    <img alt="" src="https://github.com/primer/brand/assets/2313998/62cf1c98-6b7d-46e9-a2d4-6d211a9103ad" />
    <Caption mdxType="Caption">Don't exclude the headline.</Caption>
  </Dont>
    </DoDontContainer>
    <h2>{`Anatomy`}</h2>
    <p><img parentName="p" {...{
        "src": "https://github.com/primer/brand/assets/912236/859bef31-aff0-4f75-83b1-e1dc22305f9d",
        "alt": "A river component used to showcase a security feature. The title reads \"Get security feedback with every git push\" and it includes an image showing screenshots of of a CLI prompt with the git push command and a code scanning screenshot."
      }}></img></p>
    <h3>{`Content`}</h3>
    <p>{`River provides a heading as the main title and a body text as the main content that describes the adjacent visual. The heading should be short and concise and the body should describe the feature or topic in a short paragraph.`}</p>
    <h3>{`Visual`}</h3>
    <p>{`A river can include either an image or video to illustrate the feature or topic. The media should be relevant to the content and should not be used as a decorative element.`}</p>
    <p>{`Always use high quality images and videos. Avoid using images with text or single logos. Ensure the image fills the provided container.`}</p>
    <p>{`The image is automatically styled to fit the width of the parent container. If you have bespoke styling requirements, you can disable the provided default styles and style the image manually.`}</p>
    <h3>{`Link`}</h3>
    <p>{`River can include an optional call to action to link to more detailed content about the feature or topic.`}</p>
    <h2>{`Related components`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/components/Pillar"
        }}>{`Pillar`}</a>{`: To display non-navigational related content in a compact way.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/components/Card"
        }}>{`Card`}</a>{`: To display navigational related content in a compact way.`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      